import { apiRegions } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'regions';

const config = [
  {
    actionType: 'getAll',
    apiPath: apiRegions,
    method: get,
  },
];

export const { getAll } = createThunks(typePrefix, config);
